<template>
  <div class="cbg-white-container">
    <div class="profile-info">
      <div class="pro-info-main">
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Name</b>
            </h5>
            <p>{{data.full_name}}</p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Gender</b>
            </h5>
            <p>{{data.gender}}</p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Age</b>
            </h5>
            <p>{{data.age}}</p>
          </div>
        </div>
        <div class="profile-info-list" v-if="data.blood_group">
          <div>
            <h5>
              <b>Blood Group</b>
            </h5>
            <p>{{data.blood_group}}</p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Address</b>
            </h5>
            <p>
              {{ data.address.current_address.city }},
              {{ data.address.current_address.state }},
              {{ data.address.current_address.country }}.
            </p>
          </div>
        </div>
        <div class="profile-info-list">
          <div>
            <h5>
              <b>Euthansia</b>
            </h5>
            <p>{{data.use_passive_euthanasia ? "Yes" : "No"}}</p>
          </div>
        </div>
        <div class="profile-info-list" v-if="data.donate_organs.length > 0">
          <div>
            <h5>
              <b>Organ Donor</b>
            </h5>
            <p>Yes</p>
          </div>
        </div>
        <div class="profile-info-list" v-if="data.working_diagnosis.length > 0">
          <div>
            <h5>
              <b>working Diagnosis</b>
            </h5>
            <p>Yes</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object
  }
};
</script>